/**
 * External Signup Token Storage
 *
 * This is NOT an auth token. It's a one-time/link token used to fetch
 * user-specific details for externally-sourced signup flows.
 *
 * Stored in localStorage (shared across tabs). Intentionally not cleared by `clearAuth()`.
 * Migrates from legacy sessionStorage on read.
 */

const EXTERNAL_SIGNUP_TOKEN_KEY = 'externalSignupToken';

const removeLegacy = () => {
  try {
    sessionStorage.removeItem(EXTERNAL_SIGNUP_TOKEN_KEY);
  } catch (_) {
    // ignore
  }
};

export const getExternalSignupToken = () => {
  try {
    let value = localStorage.getItem(EXTERNAL_SIGNUP_TOKEN_KEY);
    if (value === null) {
      const legacy = sessionStorage.getItem(EXTERNAL_SIGNUP_TOKEN_KEY);
      if (legacy !== null) {
        localStorage.setItem(EXTERNAL_SIGNUP_TOKEN_KEY, legacy);
        removeLegacy();
        value = legacy;
      }
    }
    return value;
  } catch (_) {
    return null;
  }
};

export const setExternalSignupToken = (token) => {
  try {
    if (!token) return;
    localStorage.setItem(EXTERNAL_SIGNUP_TOKEN_KEY, token);
    removeLegacy();
  } catch (_) {
    // ignore storage errors
  }
};

export const clearExternalSignupToken = () => {
  try {
    localStorage.removeItem(EXTERNAL_SIGNUP_TOKEN_KEY);
    removeLegacy();
  } catch (_) {
    // ignore storage errors
  }
};
